import { Container } from "../../atoms/container/Container";
import { TicketBasicDetails } from "../ticketBasicDetails/TicketBasicDetails";
import style from "./ticketdetails.module.scss";
import { UseTicketBasicDetails } from "../../../hooks/useTicketBasicDetails/UseTicketBasicDetails";
import { POCEditForm } from "../pocUpdateForm/PocEditForm";
import { InsuranceCard } from "../../molecules/insuranceCard/InsuranceCard";
import { AgentNotes } from "../../molecules/agentNotes/AgentNotes";
import { CallLogsCard } from "../../molecules/callLogsCard/CallLogsCard";
import { useOperation } from "../../../hooks/useOperation/UseOperation";
import style1 from "../ticketBasicDetails/ticketBasicDetails.module.scss";
import { Text } from "../../atoms/text/Text";
import { useState } from "react";
import { Icon } from "../../icon/Icon";
import { UseGetStoreData } from "../../../hooks/getStoreData/UseGetStoreData";
import { Button } from "../../atoms/button/Button";
import { buildCaseStudyEntries } from "../../../utils/caseStudy";
import { CallMergeButton } from "../../molecules/callMergeButton/CallMergeButton";
import { useCancelTicket } from "../../../hooks/useCancelTicket/UseCalcelTicket";

interface TicketBasicDetWrapperProps {
  children: any;
}
export const TicketBasicDetWrapper: React.FC<TicketBasicDetWrapperProps> = ({
  children,
}) => {
  const {
    transformedDataLeftSide,
    transformedDataRightSide,
    handleEditPoc,
    showPocUpdateModal,
    handleTicket
  }: any = UseTicketBasicDetails();
  const { data, callDetails, handleCallLogModal } = useOperation();
  const { getTicketData } = UseGetStoreData();
  const [showOperationTab, setShowOperationTab] = useState(false);
  const handleOperationTab = () => {
    setShowOperationTab(!showOperationTab);
  };

  const doctorClinicalNotes = getTicketData?.doctorInfo?.clinicalNotes ?? [];
  const isDoctorUsed = Array.isArray(doctorClinicalNotes)
    ? doctorClinicalNotes.some((note: any) => typeof note?.url === "string" && note.url.trim().length > 0)
    : false;

  const isAmbulanceUsed =
    typeof getTicketData?.ambulanceInfo?.status === "string" &&
    getTicketData.ambulanceInfo.status === "patientDropped";

  const { isCaseStudyUploaded } = buildCaseStudyEntries(getTicketData);
  const requiresCaseStudy = isAmbulanceUsed || isDoctorUsed;
    const shouldDisableResolved = requiresCaseStudy && !isCaseStudyUploaded;

  const { handleCancelTicket } = useCancelTicket();

  const ticketStatus = getTicketData?.ticketStatus;
  const showCallMerge = ticketStatus === "New" || ticketStatus === "Work in progress";

  return (
    <>
       <div className={style.title1}>
        <span>Ticket Number: {getTicketData?._id}</span>
      </div>
      <Container className={style.ticketDet__container}>
        <TicketBasicDetails
          handleEditPoc={handleEditPoc}
          title={"Call Details"}
          leftSideListData={transformedDataLeftSide}
          rightSideListData={transformedDataRightSide}
        />
      </Container>
      {showPocUpdateModal && <><POCEditForm handleEditPoc={handleEditPoc}/></>}

      <Container className={`${style.wrapper}`}>
        <div onClick={handleOperationTab} className={style1.head_flex}>
          <Text className={`${style1.title} ${style1.color}`} text={"Operation"} />
          <div>
            <Icon
              src={
                showOperationTab
                  ? "/images/chevron-up.png"
                  : "/images/chevron-down.png"
              }
              alt="chevron_icon"
            />
          </div>
        </div>
        <div onClick={handleOperationTab} className={style1.border}></div>
      </Container>
   
    
      {showOperationTab && <div className={style1.box}>
        <div>
          <InsuranceCard data={data?.insurancePolicies || []} />
        </div>
        <Container>
          <CallLogsCard
            data={callDetails || []}
            icon={"/images/chevron-up.png"}
            handleCallLogModal={handleCallLogModal}
          />
        </Container>
        <div>
          <AgentNotes showCaseStudy={true} />
        </div>
      </div>}
      {children}
      {shouldDisableResolved && (
        <p className={style.warning_text}>Case study is required !</p>
      )}
      <div className={style.action_buttons_row}>
        <Button
          disable={
            getTicketData?.ticketStatus === "Completed" ||
              getTicketData?.ticketStatus === "Cancelled"
              ? true
              : shouldDisableResolved
          }
          className={`${getTicketData?.ticketStatus === "Completed" ||
              getTicketData?.ticketStatus === "Cancelled" ||
              shouldDisableResolved
              ? style.is_disabled
              : style.button
            } ${style.button_small}`}
          text="Emergency Resolved"
          onClick={handleTicket}
        />
        <Button
          disable={
            getTicketData?.ticketStatus === "Cancelled" ||
            getTicketData?.ticketStatus === "Completed"
          }
          className={`${getTicketData?.ticketStatus === "Cancelled" ||
            getTicketData?.ticketStatus === "Completed"
            ? style.is_disabled
            : style.cancel_button
            } ${style.button_small}`}
          text="Cancel Ticket"
          onClick={handleCancelTicket}
        />
      </div>

      {showCallMerge && <CallMergeButton />}
    </>
  );
};
